import { usePwa } from '@/composables/usePwa.ts'

export default {
  install() {
    usePwa()
    return
    // const onSubscription = async (sub: PushSubscription): Promise<void> => {
    //   const p256dh = sub.getKey('p256dh')
    //   const auth = sub.getKey('auth')
    //   if (!p256dh || !auth) return
    //   await apiEmployeeSubscriptionsPost({
    //     body: {
    //       // alias?: string | null
    //       // employee?: string | null
    //       endpoint: sub.endpoint,
    //       auth: this.arrayBufferToBase64url(auth),
    //       p256dh: this.arrayBufferToBase64url(p256dh)
    //     }
    //   })
    // }
    //
    // // Registriere den SW mit optionalem Update-Handling
    // if (!('serviceWorker' in navigator)) {
    //   console.error('[PWA-Push] Browser does not support service worker')
    //   return
    // }
    //
    // const updateServiceWorker = registerSW({
    //   immediate: true,
    //   onOfflineReady() {
    //     console.log('[PWA] App ready for offline use')
    //   },
    //   onNeedRefresh() {
    //     console.log('[PWA] New version available')
    //     // optional: Benutzer fragen, ob neu geladen werden soll
    //   },
    //   onRegisteredSW(swScriptUrl: string, registration: ServiceWorkerRegistration | undefined) {
    //     console.log('[PWA] Registered')
    //     console.log('[PWA] swScriptUrl: ' + swScriptUrl)
    //     if (registration) {
    //       console.log('[PWA] registration given')
    //       if (registration.waiting) {
    //         console.log('[PWA] postMessage - SKIP_WAITING')
    //         registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    //       }
    //     }
    //   }
    // })
    // app.provide(UPDATE_SW_SYMBOL, updateServiceWorker)
    //
    // // Jetzt wie gehabt Push-Setup starten
    // navigator.serviceWorker.ready
    //   .then(async (registration) => {
    //     const existing = await registration.pushManager.getSubscription()
    //     if (existing) {
    //       await onSubscription(existing)
    //       return
    //     }
    //
    //     const subscription = await registration.pushManager.subscribe({
    //       userVisibleOnly: true,
    //       applicationServerKey: urlBase64ToUint8Array(options.vapidPublicKey)
    //     })
    //
    //     console.log('[PWA-Push] New subscription:', subscription)
    //
    //     await onSubscription(subscription)
    //   })
    //   .catch((err) => {
    //     console.error('[PWA-Push] Error subscribing:', err)
    //   })
  }
}
